import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ImpressionDirective, UniversityGTMService } from '@uc/web/core';
import { Product, ProductEnum } from '@uc/shared/data-models';
import { RecommendedUniversity } from '@uc/web/shared/data-models';
import {
	EngageCardCtaComponent,
	RequestBtnComponent,
	WriteReviewBtnComponent,
} from '@web/shared/ui';
import { RecommendedVisitWebsiteBtnComponent } from '../recommended-visit-website-btn/recommended-visit-website-btn.component';

@Component({
	selector: 'uc-recommended-uni-single',
	templateUrl: './recommended-uni-single.component.html',
	imports: [
		ImpressionDirective,
		EngageCardCtaComponent,
		RecommendedVisitWebsiteBtnComponent,
		RequestBtnComponent,
		WriteReviewBtnComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendedUniSingleComponent {
	uni = input.required<RecommendedUniversity>();
	componentName = input.required<string>();
	product = input<Product>(ProductEnum.Undergraduate);
	isClearing = computed(() => this.product() === ProductEnum.Clearing);

	description = computed(() => {
		let description = `${this.uni().courses_count} Courses · `;

		if (this.uni().stats.recommended_percentage) {
			description += `${this.uni().stats.recommended_percentage}% Recommended`;
		}

		return description;
	});

	constructor(private _uniGTMSrv: UniversityGTMService) {}

	onUniImpression(impression: boolean) {
		const searchOrder = this.uni().order;
		const ugso = !this.isClearing() ? searchOrder : null;
		const cleso = this.isClearing() ? searchOrder : null;
		if (impression) {
			this._uniGTMSrv.uniImpression(
				this.uni().id,
				this.uni().name,
				ugso,
				cleso,
				this.product(),
			);
		}
	}

	onUniClick() {
		const searchOrder = this.uni().order;
		const ugso = !this.isClearing() ? searchOrder : null;
		const cleso = this.isClearing() ? searchOrder : null;

		this._uniGTMSrv.uniProfileClick(
			this.uni().id,
			this.uni().name,
			ugso,
			cleso,
			this.product(),
		);
	}
}
